import React from "react";
import { Button } from "antd";
import sign from "./error_sign.svg";

import "./errorPages.scss";

export class NotFound extends React.Component<any> {
  public render() {
    return (
      <div style={{ maxHeight: "60%" }} className="flex flex-col items-center m-auto">
        <img alt={'error'} src={sign} style={{ width: 200 }} />

        <div className="errorTitle mt-12">
          <b>Error 404</b>
          <p>Page you are looking for not found</p>
        </div>

        {/* <img className='my-8' style={{ maxHeight: 300 }} src={sign} /> */}
        <div className="flex mt-24">
          {/* <Button className="mx-2" type="primary" size="large" onClick={() => history.back()}> */}
          <Button className="mx-2" type="primary" size="large" onClick={() => {}}>
            <b>Go Back</b>
          </Button>
          <Button className="mx-2" type="default" size="large" href="/home">
            <b>Return To Home Page</b>
          </Button>
        </div>
      </div>
    );
  }
}
